module.exports = __webpack_public_path__ + "img/yilianGl6.d12ea22c.png";